module.exports = __webpack_public_path__ + "static/img/UOOYAA_07_53.5a14e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/UOOYAA_07_53.jpg
// module id = xWG0
// module chunks = 7